import { render, staticRenderFns } from "./DuplicateOutlineIcon.vue?vue&type=template&id=f027d5dc&"
import script from "./DuplicateOutlineIcon.vue?vue&type=script&lang=js&"
export * from "./DuplicateOutlineIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports